import type { Middleware } from '@reduxjs/toolkit'
import { setWallet } from '../slices/user.slice'
import { authApi } from '../apis/auth.api'

export const clearRTKCacheMiddleware: Middleware = (storeApi) => (next) => (action) => {
  if (setWallet.match(action)) {
    storeApi.dispatch(authApi.util.resetApiState())
  }

  return next(action)
}
